var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-work-wechat" }, [
    _c("div", { staticClass: "content" }, [
      _vm._m(0),
      _c("div", { staticClass: "text" }, [_vm._v("基本信息")]),
      _c(
        "div",
        { staticClass: "forms" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                inline: true,
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "96px",
                autocomplete: "off",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工作微信号", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      maxlength: "20",
                      clearable: "",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "account", $$v)
                      },
                      expression: "form.account",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "微信号密码", prop: "password" } },
                [
                  _c("el-input", {
                    staticStyle: { display: "none" },
                    attrs: { type: "text", autocomplete: "username" },
                  }),
                  _c(
                    "el-input",
                    {
                      attrs: {
                        autocomplete: "new-password",
                        placeholder: "请输入",
                        maxlength: "20",
                        type: _vm.eye ? "text" : "password",
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password",
                      },
                    },
                    [
                      _c("i", {
                        class: [_vm.eye ? "i-eye" : "i-eye-hide"],
                        attrs: { slot: "suffix" },
                        on: { click: _vm.onEye },
                        slot: "suffix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "t-label",
                  attrs: { label: "微信号实名人" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-label" }, [
                            _vm._v("微信号"),
                            _c("br"),
                            _vm._v("实名人"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "204px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "30",
                      type: "textarea",
                      rows: "3",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "微信号 绑定手机号", prop: "phone" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-label" }, [
                            _vm._v("微信号"),
                            _c("br"),
                            _vm._v("绑定手机号"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      maxlength: "11",
                      clearable: "",
                      "show-word-limit": "",
                    },
                    on: { input: _vm.checkPhone },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "t-label",
                  attrs: { label: "绑定手机号所属员工" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-label" }, [
                            _vm._v("绑定手机号"),
                            _c("br"),
                            _vm._v("所属员工"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "204px" },
                    attrs: { placeholder: "自动识别", disabled: "" },
                    model: {
                      value: _vm.accountName,
                      callback: function ($$v) {
                        _vm.accountName = $$v
                      },
                      expression: "accountName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "label-star",
                  attrs: { label: "微信号好友数", prop: "friendsCount" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "custom-label" }, [
                            _vm._v("微信号"),
                            _c("br"),
                            _vm._v("好友数"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "8",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.friendsCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "friendsCount", $$v)
                      },
                      expression: "form.friendsCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "t-label",
                  attrs: { label: "微信号备注", prop: "remarks" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "204px" },
                    attrs: {
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "64",
                      type: "textarea",
                      rows: "3",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "footer",
          class: [_vm.isCollapsed ? "footer-collapsed" : ""],
        },
        [
          _c(
            "el-button",
            { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary", plain: "" }, on: { click: _vm.reset } },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.btnSave },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("新增工作微信号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }